export default __webpack_public_path__ + "static/media/13.38f844b4.mp3";